import { useEffect, useState } from "react";
import {
  Button,
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Loading,
  MaskedInput,
  TextField,
} from "../../../components";
import {
  AdzapService,
  MensagemPersonalizadaService,
  notification,
} from "../../../services";
import { encrypt, responseErros } from "../../../utils";
import { format } from "date-fns";
import { calculaDiferencaDias } from "../painel-servicos-recorrentes";

const adzapService = new AdzapService();
const mensagemPersonalizadaService = new MensagemPersonalizadaService();

const EnvioWhatsappDialog = ({
  open,
  setOpen,
  data,
  dadosEmpresa,
  initialCollapses,
  atualizarStatus,
}) => {
  const [loading, setLoading] = useState(false);
  const [celular, setCelular] = useState("");
  const [nomeCompletoCliente, setNomeCompletoCliente] = useState("");
  const [erroCelular, setErroCelular] = useState(false);

  useEffect(() => {
    if (open && data?.clienteId) {
      setCelular(data?.celular);
      setNomeCompletoCliente(data?.cliente);
    }
  }, [open]);

  const handleInputChange = (event) => {
    setErroCelular(false);
    setCelular(event.target.value);
  };

  function handleCloseDialog() {
    setLoading(false);
    setCelular("");
    setOpen(false);
    initialCollapses();
  }

  async function handleSubmit() {
    if (!celular || celular.replace(/\D/g, "")?.length < 11) {
      notification.erroGenericos("Informe um número de celular válido");
      setErroCelular(true);
      return;
    }

    await enviarMensagem();
  }

  async function enviarMensagem() {
    try {
      const getPrimeiroNome = (nomeCompleto) => {
        return nomeCompleto?.split(" ")[0] || "";
      };
      const nomeCliente = data?.cliente || nomeCompletoCliente;
      const dataVencimento = data?.dataVencimento
        ? format(new Date(data?.dataVencimento), "dd/MM/yyyy")
        : "";
      const dataCriacao = data?.createdAt;
      const dataUltimaRecorrencia = dataCriacao
        ? format(new Date(dataCriacao), "dd/MM/yyyy")
        : "";
      const quantidadeDias = calculaDiferencaDias(dataCriacao) * -1;
      const linkAgendamento = gerarLinkAgendamento();
      const texto = await mensagemPersonalizadaService.getMensagem({
        ...data,
        contexto: "servico-recorrente",
        primeiroNomeCliente: getPrimeiroNome(nomeCliente),
        nomeCompletoCliente: nomeCliente,
        dataVencimento,
        dataUltimaRecorrencia,
        quantidadeDias,
        linkAgendamento,
        ordemServico: `${data?.serieDocumento}-${data?.numeroDocumento}`,
      });

      if (!texto.isAxiosError) {
        const mensagem = await mensagemPersonalizadaService.getAll({
          contexto: "servico-recorrente",
        });
        const requestBody = {
          number: celular,
          type: "text",
          text: texto.data,
        };
        const anexo = mensagem.data.rows[0].anexo;
        if (anexo) {
          requestBody.type = "image";
          requestBody.file = anexo;
        }

        const result = await adzapService.enviarMensagem(requestBody);
        if (!result.isAxiosError) {
          handleCloseDialog();
          notification.sucessoGenericos("Notificação enviada com sucesso!");
          await atualizarStatus(data?.id, "NOTIFICADO");
        } else {
          handleCloseDialog();
          responseErros(result);
        }
      } else {
        return responseErros(texto);
      }
    } catch (error) {
      notification.erroGenericos("Falha no envio da notificação");
    } finally {
      setLoading(false);
    }
  }

  function simplificarNome(nomeCompleto) {
    const sobrenomes = nomeCompleto.split(" ");
    const primeiroNome = sobrenomes[0],
      qtdNomes = sobrenomes.length;
    let ultimoNome = sobrenomes[qtdNomes - 1];

    if (qtdNomes > 1) {
      const particulas = ["de", "da", "do", "dos", "das"];
      const penultimo = sobrenomes[qtdNomes - 2].toLowerCase();
      if (particulas.includes(penultimo)) {
        ultimoNome = sobrenomes[qtdNomes - 2] + " " + ultimoNome;
      }
    } else {
      return primeiroNome;
    }

    return `${primeiroNome} ${ultimoNome}`;
  }

  function gerarLinkAgendamento() {
    const baseUrl = window.location.origin;

    const base = {
      empresaId: dadosEmpresa.empresa?.id,
      nomeFantasia: dadosEmpresa.empresa?.fantasia,
      cnpjCpf: dadosEmpresa.empresa?.cnpjCpf,
      servicoId: data?.servicoId,
      chaveAtivo: data?.chaveAtivo,
      clienteId: data?.clienteId,
      clienteNome: simplificarNome(data?.cliente),
      celular: data?.celular,
      prestadorServicoId: data?.prestadorServicoId,
      diasSemanaFuncionamento:
        dadosEmpresa.empresa.configuracoes.diasSemanaFuncionamento,
      intervaloAgendamentos:
        dadosEmpresa.empresa.configuracoes.intervaloAgendamentos,
    };
    const basicData = encrypt(base);
    return `${baseUrl}/cadastros/agendamento-servico/${basicData}`;
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth={"xs"}
        open={open}
        onClose={() => handleCloseDialog()}
      >
        <CardHeader title="Notificação via WhatsApp" className="m-2" />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="nomeCompletoCliente"
                name="nomeCompletoCliente"
                label="Nome"
                variant="outlined"
                fullWidth
                value={nomeCompletoCliente}
                onChange={(e) => setNomeCompletoCliente(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <IconButton disabled={true}>
                      <i
                        className="ph-fill ph-user"
                        style={{ fontSize: 20 }}
                      ></i>
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MaskedInput
                id="celular"
                name="celular"
                label="Celular"
                mask="(99) 9 9999-9999"
                onChange={handleInputChange}
                margin="none"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <IconButton disabled={true}>
                      <i
                        className="ph-fill ph-device-mobile"
                        style={{ fontSize: 20 }}
                      ></i>
                    </IconButton>
                  ),
                }}
                error={erroCelular}
                value={celular || ""}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => handleSubmit()}
              >
                Enviar Documento
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <Loading loading={loading} />
      </Dialog>
    </>
  );
};

export default EnvioWhatsappDialog;
